export default "__VITE_ASSET__CB0ED9$w__"